import DateFormComponent from "components/shared/FormComponent/DateFormComponent";
import StyledButton from "components/shared/StyledButton";
import DropZoneCSV from "components/shared/UploadCsv";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "store/store";
import type { ITransferTerm } from "store/transferTermsStore";
import { addTransferTermAgreement } from "store/transferTermsStore";

import styles from "./style.module.scss";

interface ITransferTermAgreementModal {
    transferTerm: ITransferTerm | undefined;
    onEdit: (term: ITransferTerm) => void;
    onClose: () => void;
}

/**
 * Modal from the AgreementTab of the TransferTermDrawer to upload a contract (for now manually).
 */
const TransferTermAgreementModal = ({ transferTerm, onEdit, onClose }: ITransferTermAgreementModal) => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();

    const [files, setFiles] = useState<File[]>();
    const [isFileLoading, setIsFileLoading] = useState(false);

    const defaultValues: { signatureDate: Date | null } = {
        signatureDate: null,
    };

    const { control, handleSubmit } = useForm({ defaultValues });

    const onSubmit = (data: { signatureDate: Date | null }) => {
        if (files && files.length > 0) {
            setIsFileLoading(true);
            const file: File = files[0];
            const fileName = file.name ? file.name : "";
            const formData = new FormData();
            formData.append("file", file, fileName);

            if (transferTerm) {
                dispatch(
                    addTransferTermAgreement({
                        data: formData,
                        transferTermId: transferTerm?.id,
                        signatureDate: data.signatureDate,
                    }),
                ).then((resp) => {
                    if (resp.meta.requestStatus === "fulfilled") {
                        setIsFileLoading(false);
                        onEdit(transferTerm);
                        onClose();
                    }
                });
            }
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={styles["agreement-form"]}>
            <DateFormComponent
                control={control}
                controlName="signatureDate"
                label={t("TransferTerms.AgreementModal.SignatureDate")}
                required
                maxYearDistance={5}
            />
            <DropZoneCSV setFile={setFiles} file={files} acceptedFilesTypeList={{ "application/pdf": [".pdf"] }} />
            <StyledButton buttonType="primary" type="submit" disabled={isFileLoading}>
                {t("TransferTerms.AgreementModal.SaveContract")}
            </StyledButton>
        </form>
    );
};

export default TransferTermAgreementModal;
